import {Textarea, TextInput} from "@/components/inputs";
import Image from "next/image";
import {DesktopSize} from "@/components/responsive";
import {APP_NAME, LOCAL_IMAGE_URL, REQ_TYPES} from "@/constants/general-constants";
import {fetchData} from "@/utils/global-functions";
import {useState} from "react";
import {toast} from "react-toastify";
import {isValidContactForm} from "@/validations/contact-us-schema";
import parse from "html-react-parser";

const CONTACT_FORM_PARAMS = {
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: ""
}

export default function ContactWithPol({data = {}}) {

    const {contact_form_text = ""} = data.data || {};

    const [contactForm, setContactForm] = useState(CONTACT_FORM_PARAMS);

    const submitFormHandler = async (e) => {
        e.preventDefault();

        const validateResult = await isValidContactForm(contactForm);
        if(!validateResult.isValid) return;

        const data = await fetchData("contact-request", REQ_TYPES.POST, contactForm);

        if (!data.error) {
            toast.success("پیام شما ثبت شد");
            setContactForm(CONTACT_FORM_PARAMS);
        }
    }

    const changeHandler = ({target: {name, value}}) => {
        setContactForm(prevState => ({...prevState, [name]: value}))
    }

    return (
        <section className="container flex justify-between items-start gap-x-16 mt-12">
            <div className="text-pol-dark-800 pt-3 mobile-content-p">
                <h1 className="font-bold text-xl lg:text-2xl">تماس با {APP_NAME}</h1>
                <div className="text-justify mt-[1.25rem] pol-leading-lg">{parse(contact_form_text ? contact_form_text : "<span></span>")}</div>

                <form onSubmit={submitFormHandler} className="mt-[1.5rem]">
                    <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-5 gap-y-[1.8rem]">
                        <TextInput
                            id="name"
                            name="name"
                            label="نام و نام خانوادگی"
                            requiredLabel
                            placeholder="مثال: علی علیزاده"
                            value={contactForm.name}
                            onChange={changeHandler}
                        />
                        <TextInput
                            id="mobile"
                            name="mobile"
                            label="شماره همراه"
                            requiredLabel
                            placeholder="09120000000"
                            pattern="[0]{1}[0-9]{10}"
                            type="tel"
                            value={contactForm.mobile}
                            onChange={changeHandler}
                        />
                        <TextInput
                            id="email"
                            name="email"
                            label="ایمیل"
                            placeholder="email@example.com"
                            type="email"
                            value={contactForm.email}
                            onChange={changeHandler}
                        />
                        <TextInput
                            id="subject"
                            name="subject"
                            label="موضوع پیام"
                            requiredLabel
                            placeholder="مثال: درخواست مشاوره"
                            value={contactForm.subject}
                            onChange={changeHandler}
                        />
                    </div>
                    <div className="mt-[1.8rem]">
                        <Textarea
                            id="message"
                            name="message"
                            rows={4}
                            label="توضیحات"
                            requiredLabel
                            placeholder="متن خود را اینجا بنویسید"
                            value={contactForm.message}
                            onChange={changeHandler}
                        />
                    </div>
                    <div className="mt-6">
                        <button type="submit"
                                className="btn-main !rounded-[0.688rem] text-sm font-semibold px-7 py-3.5">ارسال
                            درخواست
                        </button>
                    </div>
                </form>
            </div>

            <DesktopSize>
                <div
                    className="relative min-h-full h-[38.938rem] min-w-[18.188rem] overflow-hidden rounded-l-[1.875rem] rounded-br-[1.875rem] rounded-tr-[3.25rem]">
                    <span className="w-full h-full absolute bottom-0 left-0 z-10"
                          style={{background: "linear-gradient(0deg, rgba(255,255,255,1) 15%, rgba(255,255,255,0) 75%)"}}/>
                    <div className="relative w-full h-full">
                        <Image
                            src={LOCAL_IMAGE_URL + "pot-bg.webp"}
                            fill
                            alt="Contact us"
                            className="object-cover"
                        />
                    </div>
                </div>
            </DesktopSize>
        </section>
    )
}
